export const name = 'clickHandlerRegistrar' as const
